import type * as Types from 'app/types/graphql';

export type UsageFeeBillSelectFragment = Pick<
  Types.UsageFeeBill,
  'id' | 'cycleStartDate' | 'cycleEndDate' | 'status' | 'price' | 'usageAmount' | 'paidAt'
> & {
  revenue?: Types.Maybe<Pick<Types.ShopPlatformRevenue, 'id' | 'date' | 'totalRevenue'>>;
  shopPlatformPlan?: Types.Maybe<Pick<Types.ShopPlatformPlan, 'id' | 'planID'>>;
};

export type UsageFeeBillEdgeSelectFragment = Pick<Types.UsageFeeBillConnection, 'totalCount'> & {
  edges?: Types.Maybe<
    Array<
      Pick<Types.UsageFeeBillEdge, 'cursor'> & {
        node?: Types.Maybe<
          Pick<
            Types.UsageFeeBill,
            'id' | 'cycleStartDate' | 'cycleEndDate' | 'status' | 'price' | 'usageAmount' | 'paidAt'
          > & {
            revenue?: Types.Maybe<Pick<Types.ShopPlatformRevenue, 'id' | 'date' | 'totalRevenue'>>;
            shopPlatformPlan?: Types.Maybe<Pick<Types.ShopPlatformPlan, 'id' | 'planID'>>;
          }
        >;
      }
    >
  >;
  pageInfo: Pick<Types.PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>;
};

export const UsageFeeBillSelectFragmentDoc = `
    fragment UsageFeeBillSelect on UsageFeeBill {
  id
  cycleStartDate
  cycleEndDate
  revenue {
    ...ShopPlatformRevenueSelect
  }
  status
  shopPlatformPlan {
    id
    planID
  }
  price
  usageAmount
  paidAt
}
    `;
export const UsageFeeBillEdgeSelectFragmentDoc = `
    fragment UsageFeeBillEdgeSelect on UsageFeeBillConnection {
  edges {
    cursor
    node {
      ...UsageFeeBillSelect
    }
  }
  pageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
  totalCount
}
    `;
